module.exports = __webpack_public_path__ + "static/img/chai.53c806f0.png";